import api from '@/api/company'
import { errorHandler } from '../exports/error_management'

const getParsedData = (key, configurations, valueType = 'string') => {
    try {
        const data = configurations.find(x => x.key == key)
        switch (valueType) {
            case 'array':
            case 'object':
                return JSON.parse(data.text_value)
            case 'string':
                return data.text_value
            case 'int':
                return parseInt(data.text_value, 10)
        }
    } catch (err) {
        switch (valueType) {
            case 'array':
                return []
            case 'object':
                return {}
            case 'string':
                return null
            case 'int':
                return null
        }
    }
}

const state = {
    settings: {},
    ///keys
    settingKeys: {
        assetFrequencyKey: 'AssetFrequencySettingsKey',
        companyNoteKey: 'companyNotesReferenceSettings',
        orderHeaderKey: 'orderHeaderUploadSettings',
        orderDetailKey: 'orderDetailsUploadSettings',
        defaultRoleKey: 'defaultRoleForNotificationSettings',
        customerUploadKey: 'customerUploadSettings',
        inventoryUploadKey: 'inventoryUploadSettings',
        assetUploadKey: 'assetUploadSettings',
        inventoryUsageKey: 'inventoryUsageSettings',
        taskTypeKey: 'taskTypeSettings',
        crmsettingsKey: 'crmsettingkey',
    },
}

const getters = {
    configurations(state) {
        console.log(
            'state.settings.configurations',
            state.settings.configurations
        )
        return state.settings.configurations
    },

    assetFrequencies(state) {
        return getParsedData(
            state.settingKeys.assetFrequencyKey,
            state.settings.configurations,
            'array'
        )
    },

    companyNotes(state) {
        return getParsedData(
            state.settingKeys.companyNoteKey,
            state.settings.configurations,
            'array'
        )
    },

    defaultRole(state) {
        return getParsedData(
            state.settingKeys.defaultRoleKey,
            state.settings.configurations,
            'int'
        )
    },

    taskTypeValue(state) {
        return getParsedData(
            state.settingKeys.taskTypeKey,
            state.settings.configurations,
            'object'
        )
    },
    crmSettingValue(state) {
        return getParsedData(
            state.settingKeys.crmsettingsKey,
            state.settings.configurations,
            'object'
        )
    },

    customerUploadSettings(state) {
        return getParsedData(
            state.settingKeys.customerUploadKey,
            state.settings.configurations,
            'object'
        )
    },

    assetUploadSettings(state) {
        return getParsedData(
            state.settingKeys.assetUploadKey,
            state.settings.configurations,
            'object'
        )
    },

    /*  customerUploadSettings(state) {
        return getParsedData(
            state.settingKeys.customerUploadKey,
            state.settings.configurations,
            'object'
        )
    }, */
}

const mutations = {
    SET_SETTINGS(state, settings) {
        console.log('mutate settings data', settings)
        state.settings = settings
    },

    SET_CONFIGURATIONS(state, configuration) {
        console.log('mutate configuration data', configuration)
        const settings = { ...(state.settings || {}) }

        settings.configurations = settings.configurations || []
        let idx = settings.configurations.findIndex(
            x => x.key === configuration.key
        )
        if (idx === -1) idx = settings.configurations.length
        settings.configurations.splice(idx, 1, configuration)

        console.log('settings', settings)
        state.settings = settings
    },
}

const actions = {
    fetch({ commit }) {
        return api
            .fetch()
            .then(result => {
                console.log('fetch company data', result)
                commit('SET_SETTINGS', result.data.success.data)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    update({ commit }, model) {
        return api
            .update(model)
            .then(result => {
                console.log('update company data', result)
                commit('SET_SETTINGS', result.data.success.data)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    fetchConfiguration({ commit }, key) {
        return api
            .fetchConfiguration(key)
            .then(result => {
                const data = result.data.success.data
                let configuration = {}
                if (data.length > 0) configuration = data[0]
                console.log('fetchConfiguration data', configuration)
                commit('SET_CONFIGURATIONS', configuration)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    updateConfiguration({ commit }, { key, text_value, bool_value }) {
        return api
            .updateConfiguration({ key, text_value, bool_value })
            .then(result => {
                const configuration = result.data.success.data
                console.log('updateConfiguration data', configuration)
                commit('SET_CONFIGURATIONS', configuration)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    deleteConfiguration({ dispatch }, key) {
        return api
            .deleteConfiguration(key)
            .then(() => {
                dispatch('fetch')
            })
            .catch(err => {
                errorHandler(err)
            })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
